import React from 'react';
import {Box} from "@mui/material";
import {sx} from './sx'
import PageLayout from "@view/layout/pageLayout/PageLayout";


const HomePage = () => {
    return (
        <PageLayout>
            <Box sx={sx.root}>
                TREK 2.0
            </Box>
        </PageLayout>
    )
};

export default HomePage;